"use client";

import { useParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { SUCCESS_LIST, SuccessListItemType } from "../../constants/people";

export const useDetailSuccessData = () => {
  const params = useParams();
  const t = useTranslations("success");

  const { slug } = params;

  const data = SUCCESS_LIST.find(item => item.slug === slug) as SuccessListItemType;

  return {
    title: t(data.title),
    qualification: t(data.qualification),
    image: data.image,
    name: t(data.name),
    content: data.content,
    avatar: data.avatar,
  };
};
